import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/user/webuser',
  title: '表单用户管理',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
